// extracted by mini-css-extract-plugin
export var first = "first__hdAq";
export var heading = "heading__zSVd";
export var headingContainer = "heading-container___4jk";
export var paragraphContainer = "paragraph-container__YWxK";
export var second = "second___aBl";
export var third = "third__qf8z";